module.exports = __webpack_public_path__ + "img/CRT_Weapon-Sword-05.103a449f.png";